import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import ACTIONS from '../../../store/actions';
import { createLogic } from 'redux-logic';
import { gridDataSelector } from '../../selectors/grid';
var fullyLoadedLogic = createLogic({
  type: [ACTIONS.GRID_DATA_GET_RESOLVED],
  process: function process(_ref, dispatch, done) {
    var getState = _ref.getState,
        action = _ref.action;
    var id = action.view.id;
    var state = getState();
    var view = state.grid.views[id];
    var fullyLoaded = false;
    var gridData = gridDataSelector(state, {
      id: id
    });
    var loadedItems = [];

    for (var itemIdx in view.all) {
      var itemId = view.all[itemIdx];

      if (gridData[itemId]) {
        loadedItems.push({
          id: itemId,
          data: gridData[itemId]
        });
      }
    }

    fullyLoaded = loadedItems.length === view.count;
    if (view.fullyLoaded === fullyLoaded) return done();

    var nextView = _objectSpread({}, view, {
      fullyLoaded: fullyLoaded
    });

    dispatch({
      type: ACTIONS.GRID_VIEW_SET,
      view: nextView,
      action: action
    });
    done();
  }
});
export default [fullyLoadedLogic];